import { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [onboarded, setOnboarded] = useState(null);
  const location = useLocation();

  useEffect(() => {
    let unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAuthenticated(false);
        setOnboarded(null);
        setLoading(false);
        return;
      }
      setIsAuthenticated(true);
      // Check onboarded field in companyUsers
      const userRef = doc(db, 'companyUsers', user.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        setOnboarded(!!userSnap.data().onboarded);
      } else {
        setOnboarded(false);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return <div className="spinner" style={{margin: "2rem auto"}} />;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  if (onboarded === false) return <Navigate to="/onboard" state={{ from: location }} replace />;
  return children;
}
